import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withStyles } from '@material-ui/core';
import { PulseLoader } from 'halogenium';
import '../../components/Loader/loader.css';

export class RegisterGarminAccount extends Component {
  async componentDidMount() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params && params.oauth_token) {
      await this.props.garmin.getRegisterAccount(params.oauth_token, params.secret, params.oauth_verifier);
      const { account } = this.props.garmin.toJS();
      if (account && account.oauth_token && account.oauth_token_secret) {
        const { patientId, accountId, username, pathname, tenantId } = this.props.match.params;
        try {
          let data = {};
          // decode account with Base64
          const garminAccount = atob(username);
          const decodePathName = atob(pathname);
          data.username = garminAccount;
          data.userAccessToken = account.oauth_token;
          data.userAccessTokenSecret = account.oauth_token_secret;
          data.tenantId = tenantId;

          if (patientId) {
            const result = await this.props.smartwatch.createSmartwatchAccount(data);
            if (result.statusCode === 200) {
              await this.props.smartwatch.assignPatientAccount(+patientId, result.body.id);
              this.props.history.push(`${decodePathName}`);
            }
          } else if (accountId) {
            data.accountId = +accountId;
            await this.props.smartwatch.updateSmartwatchAccount(data);
            this.props.history.push(`${decodePathName}`);
          }
        } catch (e) {
          console.log('error: ', e);
        }
      }
    }
  }

  render() {
    return (
      <div>
        <div style={{ textAlign: 'center', marginTop: '50px', fontSize: '28px' }}>please waiting...</div>
        <PulseLoader loading={true} className='loader' color='#3b3b3b' size='16px' />
      </div>
    );
  }
}

export const page = inject('smartwatch', 'garmin')(observer(RegisterGarminAccount));
export default withStyles({ withTheme: true })(page);
